import { FormEvent, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../lib/api';

export function PublishPage() {
  const { assetId = '' } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.publishAsset(assetId, {
        title: title.trim() || undefined,
        description: description.trim() || undefined,
      });
      navigate(`/spin/${assetId}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Publish failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Publish</h1>
      <p className="muted">Publishing is explicit and separate from uploading or generating.</p>
      <form className="panel" style={{ marginTop: '1rem', maxWidth: 560 }} onSubmit={onSubmit}>
        <label className="field">
          Title
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Public title" />
        </label>
        <label className="field" style={{ marginTop: '0.75rem', display: 'block' }}>
          Description
          <textarea
            className="prompt"
            style={{ minHeight: 120 }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <p className="muted" style={{ fontSize: '0.85rem' }}>
          Rights declaration and license/price controls are recorded server-side. A private library
          entitlement does not auto-permit public redistribution.
        </p>
        {error && <p className="err">{error}</p>}
        <button className="btn primary" type="submit" disabled={busy}>
          Publish to channel
        </button>
      </form>
    </main>
  );
}
